import React, { useEffect, useState } from 'react';

import { IBlogPost } from '@/types/contentful';

import { BlockContainer, Layout, Column } from '../Layout';
import { Text } from '../Text';

import BlogPostCard from '../BlogComponents/BlogPostFeed/BlogPostCard';
import axios from 'axios';

interface MorePostProps {
  sysId: string;
}

export function MorePosts({ sysId }: MorePostProps) {
  const [linkedPosts, setLinkedPosts] = useState<IBlogPost[]>([]);

  const fetchPosts = async (id: string) => {
    const res = await axios.post('/api/blog/linked-post', { id });
    setLinkedPosts(res?.data);
  };

  useEffect(() => {
    fetchPosts(sysId);
  }, [sysId]);

  if (!linkedPosts.length) return null;

  const [firstPost, secondPost] = linkedPosts;

  return (
    <BlockContainer data-testid="linked-posts">
      <Layout gutter={{ 0: 'ml', tablet: 'm', desktop: 'xl' }}>
        <Column size={{ 0: 10, desktop: 8 }}>
          {(firstPost || secondPost) && (
            <Text as="h2" fontSize={{ 0: 'm', tablet: 'xl' }} fontWeight="500">
              More posts:
            </Text>
          )}
        </Column>
        <Column size={{ 0: 12, tablet: 6, desktop: 5 }}>
          {firstPost && <BlogPostCard {...firstPost?.fields} />}
        </Column>
        <Column size={{ 0: 12, tablet: 6, desktop: 5 }}>
          {secondPost && <BlogPostCard {...secondPost?.fields} />}
        </Column>
      </Layout>
    </BlockContainer>
  );
}
